var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRendernet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53961 29.6024L8.80539 26.9053C9.32834 25.7909 10.4483 25.0794 11.6793 25.0794H18.3073C19.5382 25.0794 20.6582 25.7909 21.1811 26.9053L22.4469 29.6024C22.5608 29.8451 22.8046 30 23.0726 30C28.3728 30 31.7008 24.2804 29.0819 19.6725L19.3372 2.5276C18.4492 0.9652 16.7904 0 14.9933 0C13.1961 0 11.5374 0.9652 10.6493 2.5276L0.904668 19.6725C-1.7143 24.2804 1.61375 30 6.91388 30C7.18189 30 7.42575 29.8451 7.53961 29.6024ZM22.3722 16.8776C23.4373 16.268 23.4373 14.732 22.3722 14.1224L12.3039 8.3598C11.2457 7.7541 9.92813 8.5181 9.92813 9.7374V21.2626C9.92813 22.4819 11.2457 23.2459 12.3039 22.6402L22.3722 16.8776Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRendernet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_rendernet.a3f1d76e01d5b030027e64e1292cab5e.svg";